import React, { FC, ReactNode } from "react";

import { Card } from "../../../../components/card/Card";

type Props = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  /**
   * A widget of the client profile grid (Work, Notes, Files, Emails,
   * Invoices, Tags): same height (386 px inside the 1 px border = 388 px) and
   * title (19 px) as the Invoices widget (QA batch 18).
   */
  grid?: boolean;
};

export const ProfileWidgetCard: FC<Props> = ({
  title,
  action,
  children,
  className = "",
  bodyClassName = "",
  grid = false,
}) => {
  return (
    <Card extraClasses={`overflow-hidden ${className}`}>
      <div className={grid ? "flex h-[386px] min-w-0 flex-col" : "min-w-0"}>
        <div
          className={
            grid
              ? "flex min-w-0 shrink-0 items-center justify-between gap-3 px-[22px] pt-[22px]"
              : "flex min-w-0 items-center justify-between gap-3 px-5 pt-5"
          }>
          <span
            className={
              grid
                ? "min-w-0 break-words text-[19px] font-extrabold text-[#1F2433]"
                : "min-w-0 break-words text-[17px] font-extrabold text-[#1F2433]"
            }>
            {title}
          </span>
          {action}
        </div>
        <div
          className={grid ? `min-h-0 flex-1 ${bodyClassName}` : bodyClassName}>
          {children}
        </div>
      </div>
    </Card>
  );
};
